import { render, staticRenderFns } from "./outboundreportmanagementtable.vue?vue&type=template&id=4d4a79ba&scoped=true&"
import script from "./outboundreportmanagementtable.vue?vue&type=script&lang=js&"
export * from "./outboundreportmanagementtable.vue?vue&type=script&lang=js&"
import style0 from "./outboundreportmanagementtable.vue?vue&type=style&index=0&id=4d4a79ba&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d4a79ba",
  null
  
)

export default component.exports